import loadable from '@loadable/component';

export const VtoLooksCarousel = loadable(() => import('./VtoLooksCarousel'));
